import { createSlice } from '@reduxjs/toolkit';
import {
  // createWorkflow,
  // deleteWorkflow,
  fetchWorkflowSteps,
  // fetchWorkflowById,
  // fetchWorkflowTypes,
  updateWorkflowSteps,
  // updateWorkflow,
} from './actions';

const initialState = {
  // Unused: only workflowSteps are read by the UI.
  // items: [],
  // selected: null,
  // loading: false,
  // saving: false,
  workflowSteps: null,
  workflowStepsLoading: false,
  workflowStepsSaving: false,
  error: null,
};

const workflowSlice = createSlice({
  name: 'workflow',
  initialState,
  reducers: {
    // Unused: nothing dispatches these helpers.
    // clearWorkflowError(state) {
    //   state.error = null;
    // },
    // clearSelectedWorkflow(state) {
    //   state.selected = null;
    // },
    // resetWorkflowState() {
    //   return initialState;
    // },
  },
  extraReducers: (builder) => {
    builder
      // Unused: matching thunks are not dispatched.
      // .addCase(fetchWorkflowTypes.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(fetchWorkflowTypes.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.items = Array.isArray(action.payload)
      //     ? action.payload
      //     : action.payload?.data ?? action.payload?.items ?? [];
      // })
      // .addCase(fetchWorkflowTypes.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload?.message ?? action.error?.message ?? 'Failed to fetch workflows';
      // })

      // .addCase(fetchWorkflowById.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(fetchWorkflowById.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.selected = action.payload?.data ?? action.payload;
      // })
      // .addCase(fetchWorkflowById.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload?.message ?? action.error?.message ?? 'Failed to fetch workflow by ID';
      // })

      .addCase(fetchWorkflowSteps.pending, (state) => {
        state.workflowStepsLoading = true;
        state.error = null;
        state.workflowSteps = null;
      })
      .addCase(fetchWorkflowSteps.fulfilled, (state, action) => {
        state.workflowStepsLoading = false;
        state.workflowSteps = action.payload?.data ?? action.payload;
      })
      .addCase(fetchWorkflowSteps.rejected, (state, action) => {
        if (action.meta.aborted) return;
        state.workflowStepsLoading = false;
        state.error = action.payload?.message ?? action.error?.message ?? 'Failed to fetch workflow steps';
      })

      .addCase(updateWorkflowSteps.pending, (state) => {
        state.workflowStepsSaving = true;
        state.error = null;
      })
      .addCase(updateWorkflowSteps.fulfilled, (state, action) => {
        state.workflowStepsSaving = false;
        state.workflowSteps = action.payload?.data ?? action.payload;
      })
      .addCase(updateWorkflowSteps.rejected, (state, action) => {
        state.workflowStepsSaving = false;
        state.error = action.payload?.message ?? action.error?.message ?? 'Failed to update workflow steps';
      });

      // .addCase(createWorkflow.pending, (state) => {
      //   state.saving = true;
      //   state.error = null;
      // })
      // .addCase(createWorkflow.fulfilled, (state, action) => {
      //   state.saving = false;
      //   const createdItem = action.payload?.data ?? action.payload;
      //   state.items = [createdItem, ...state.items.filter((item) => item?.id !== createdItem?.id)];
      //   state.selected = createdItem;
      // })
      // .addCase(createWorkflow.rejected, (state, action) => {
      //   state.saving = false;
      //   state.error = action.payload?.message ?? action.error?.message ?? 'Failed to create workflow';
      // })

      // .addCase(updateWorkflow.pending, (state) => {
      //   state.saving = true;
      //   state.error = null;
      // })
      // .addCase(updateWorkflow.fulfilled, (state, action) => {
      //   state.saving = false;
      //   const updatedItem = action.payload?.data ?? action.payload;
      //   state.items = state.items.map((item) =>
      //     item?.id === updatedItem?.id ? updatedItem : item,
      //   );
      //   state.selected = updatedItem;
      // })
      // .addCase(updateWorkflow.rejected, (state, action) => {
      //   state.saving = false;
      //   state.error = action.payload?.message ?? action.error?.message ?? 'Failed to update workflow';
      // })

      // .addCase(deleteWorkflow.pending, (state) => {
      //   state.saving = true;
      //   state.error = null;
      // })
      // .addCase(deleteWorkflow.fulfilled, (state, action) => {
      //   state.saving = false;
      //   const id = action.payload?.id ?? action.meta?.arg;
      //   state.items = state.items.filter((item) => item?.id !== id);
      //   if (state.selected?.id === id) {
      //     state.selected = null;
      //   }
      // })
      // .addCase(deleteWorkflow.rejected, (state, action) => {
      //   state.saving = false;
      //   state.error = action.payload?.message ?? action.error?.message ?? 'Failed to delete workflow';
      // });
  },
});

// export const { clearWorkflowError, clearSelectedWorkflow, resetWorkflowState } =
//   workflowSlice.actions;

export default workflowSlice.reducer;
